import { render, staticRenderFns } from "./savePracticeQuestion.vue?vue&type=template&id=2fb11fd7&"
import script from "./savePracticeQuestion.vue?vue&type=script&lang=js&"
export * from "./savePracticeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./savePracticeQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports